import { gql } from "@apollo/client"
import Form from "components/common/form/Form"
import Input from "components/common/form/inputs/Input"
import { graph } from "config/axios-context"
import { useEffect, useState } from "react"
import { SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables } from "types/graphql"
import { useContext } from "react";
import { getAppContext } from 'config/AppContext';
import { useTranslation } from "react-i18next"
import { getSeasonData, getSeasonType, SeasonType } from "types/season-type"
import CheckboxInput from "components/common/form/inputs/CheckboxInput"
import FormActions from "components/common/form/partials/FormActions"
import { CoreFormPropsType } from "types/form-types"
import LoadingWrapper from "components/common/loading/LoadingWrapper"


type SeasonFormPropsType = CoreFormPropsType<SeasonType, SaveSeasonMutationMutation>

const saveSeasonMutation = gql`
mutation saveSeasonMutation($model:SeasonInput!) {
    season(model: $model) {
      name,
      id,
      active
    }
  }
`;

const SeasonForm = (props: SeasonFormPropsType) => {
    const context = getAppContext(useContext);
    const [t] = useTranslation();
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState<SeasonType>({
        id: 0,
        name: '',
        active: false,
        ...(typeof props.model == 'object' ? props.model : {})
    });

    // #region loadData

    useEffect(() => {
        const id = Number(props.model)
        if (id) {
            loadData(id).then();
        }
    }, [props.model]);

    const loadData = async (id: number) => {
        setLoading(true);
        try {
            const response = await getSeasonData(id);
            if (response?.season) {
                setModel(response?.season);
            }
        } catch (error: any) {
            console.error(error);
            context.notify('error', error.toString());
        } finally {
            setLoading(false);
        }
    }
    // #endregion loadData

    const onSubmit = async () => {
        const request = await graph<SaveSeasonMutationMutation, SaveSeasonMutationMutationVariables>({
            query: saveSeasonMutation,
            variables: {
                model: {
                    ...model
                }
            }
        });

        if (request.errors) {
            console.error(request.errors);
            context.notify('error', t('form.submit.error'));
        } else {
            context.notify('success', t('form.submit.save'));
            props.onSubmit(getSeasonType(request), request);
        }
    };

    return (
        <LoadingWrapper loading={loading}>
            <Form onSubmit={onSubmit} name={props.name ?? 'season-form'} id={props.formId} >
                <fieldset>
                    <Input
                        value={model.name}
                        onChange={c => setModel({ ...model, name: c || '' })}
                        name='season-input-name'
                        required
                        pattern="Season[ ][0-9]{4,4}"
                        label='fields.name.name'
                    />
                    <CheckboxInput
                        value={model.active}
                        onChange={c => setModel({ ...model, active: c || false })}
                        name='season-input-active'
                        label='fields.active.name'
                    />
                </fieldset>
                <FormActions />
            </Form>
        </LoadingWrapper>
    )
}
export default SeasonForm;
